import { render } from "./RandomBg.vue?vue&type=template&id=3c9c7cd6&scoped=true"
import script from "./RandomBg.vue?vue&type=script&lang=js"
export * from "./RandomBg.vue?vue&type=script&lang=js"

import "./RandomBg.vue?vue&type=style&index=0&id=3c9c7cd6&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9c7cd6"]])

export default __exports__